/**
 * Add Binding to Shape
 * Post-creation utility to bind a standalone shape to a data source
 */

import * as Y from 'yjs';
import type { ShapeDataBinding } from '../models/ShapeDataBinding';
import { createNewRecordBinding } from './createNewRecordBinding';
import { ShapeMapAdapter } from '../../../lib/diagram/ShapeMapAdapter';
import { ShapePersistenceGateway } from '../../../lib/diagram/shapeGeometry';

export interface AddBindingToShapeOptions {
  doc: Y.Doc;
  shapeId: string;
  sourceId: string;
  userId: string;
  initialData?: Record<string, unknown>;
}

export function addBindingToShape(
  options: AddBindingToShapeOptions,
): ShapeDataBinding | null {
  const { doc, shapeId, sourceId, userId, initialData } = options;

  const binding = createNewRecordBinding({
    shapeId,
    sourceId,
    userId,
    initialData,
  });

  const shapes = new ShapePersistenceGateway(new ShapeMapAdapter(doc.getMap('shapes')));
  const shape = shapes.get(shapeId);
  if (!shape) return null;

  doc.transact(() => {
    const props = (shape.props as Record<string, unknown>) ?? {};
    props.dataBinding = binding;
    shapes.patch(shapeId, { props });
  });

  return binding;
}
